export const propId = ({ id }: { id: number }) => id;

export const propIdString = ({ id }: { id: string }) => id;
